import { OptionTypes } from "components/types/types";

export const fromGetDayToWeekDay = (day: number) => {
    let weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let weekDay = weekDays[day];

    return weekDay
}

export const fromGetDayToFullWeekDay = (day: number) => {
    let weekDays = ["Sunday", "Monday", "Tuesday", "Wedsday", "Thursday", "Friday", "Saturday"];
    let weekDay = weekDays[day];

    return weekDay
}

export const addZero = (par: number | undefined) => {
    let parFormatted

    if (par) {
        if (par < 10 && par > 0) {
            parFormatted = `0${par}`
        } else if (par === 0) {
            parFormatted = "00"
        } else {
            parFormatted = par
        }
    } else {
        parFormatted = "00"

    }

    return parFormatted
}

export const fromGetMonthToMonthName = (month: number) => {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let monthName = months[month];

    return monthName
}


export const formatTime = (hours: number, minutes: number) => {
    let ampm = hours >= 12 ? 'pm' : 'am';
    let textHour = hours % 12
    let textMinutes = addZero(minutes)
    const strTime = `${textHour === 0 ? "12" : addZero(textHour)}:${textMinutes} ${ampm}`;
    return strTime;
}

export const dayMonthYearString = (par: string) => {
    return par.substring(0, 10)
}

export const chatDepartmentFormat = (par: string | undefined) => {
    if (par && par.length >= 15) {
        return `${par.substring(0, 15)}...`
    } else {
        return par
    }
}

export const formatTitle = (par: string | undefined, qty:number) => {
    if (par && par.length >= qty) {
        return `${par.substring(0, (qty-3))}...`
    } else {
        return par
    }
}

 // const startSlot = new Date(0,0,0,9,0,0)
        // const finishSlot = new Date(0,0,0,17,30,0)
        // const durationInMinutes = 30 
export function SlotGenerator(start:Date, finish:Date, duration:number){
    const startInMinutes = (start.getHours() * 60 ) + (start.getMinutes())
    const finishInMinutes = (finish.getHours() * 60 ) + (finish.getMinutes())
    const numberOfSlot = ((finishInMinutes - startInMinutes) / duration) + 1
    const arrNumberSlot = Array.from({length: numberOfSlot}, (_, index) => index + 1);
    const durationInMs = 30 * 60000
    const slots: OptionTypes[] = arrNumberSlot.map((n, i) =>{
        let dateSlotInMillisecond = start.getTime() + ( durationInMs * i)
        let dateSlot = new Date(dateSlotInMillisecond)
        let newSlot = {
            label:`${addZero(dateSlot.getHours())}:${addZero(dateSlot.getMinutes())}`,
            value: dateSlot.toISOString()
        }
        return newSlot
    })

    return slots
}
